import React, { useState, useEffect } from "react";
import { RingLoader } from "react-spinners";
import AVReactPlayer from "./AVReactPlayer";
import styled from "styled-components";

const Container = styled.div`
    /* Стили для контейнера */
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em; // Измените размер шрифта для увеличения кнопки
    padding: 10px 20px; // Увеличьте отступы для увеличения кнопки
    border-radius: 5px;
    font-weight: bold;
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; // Use the full height of the viewport
    width: 100%; // Use the full width
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const UploadMessage = styled.div`
    text-align: center;
    color: #f44336;
    font-size: 28px;
    margin-bottom: 10px;
`;

const AVRepair = (props) => {
    const {
        titleDownload,
        titleDelete,
        titleReady,
        titleCurrentFile,
        titleRepairAnotherVideo,
        titleRepair,
        titleVariant1,
        titleVariant2,
        titleVariant3,
        titleVariant4,
        titleVariant5,
        tip1,
        tip2,
        tip4,
        titleUpload,
        titleHorizontal,
        titleVertical,
    } = props.attributes;

    const [isLoading, setIsLoading] = useState(false);
    const [fileId, setfileId] = useState(props.fileId);
    const [fileName, setfileName] = useState(props.fileName);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showVariants, setShowVariants] = useState(true);
    const [showUploadMessage, setShowUploadMessage] = useState(false);
    const [showVariant5Message, setShowVariant5Message] = useState(false);
    const [selectedOrientation, setSelectedOrientation] =
        useState("horizontal"); // по умолчанию горизонтальное

    const handleRepair = async (variant) => {
        if (variant === 4) {
            setShowUploadMessage(true);
            setShowVariant5Message(false);
            return;
        }

        if (variant === 5) {
            setShowVariant5Message(true);
            setShowUploadMessage(false);
            return;
        }

        setIsLoading(true);
        setShowVariants(false);
        setShowUploadMessage(false);
        setShowVariant5Message(false);

        const requestBody = {
            variant: variant,
            fileId: props.fileId,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/repairVideo?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleRepair5 = async () => {
        setIsLoading(true);
        setShowVariants(false);
        setShowVariant5Message(false);

        const requestBody = {
            fileId: props.fileId,
            selectedOrientation: selectedOrientation,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/repairVideoVariant5?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowVariants(true);
        setShowUploadMessage(false);
        props.setShowUploader(true);
    };

    function getFileName(url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }

    const reloadPage = () => {
        setShowVariants(true);
        location.reload();
    };

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("fileId", props.fileId);

            try {
                setIsLoading(true);
                setShowVariants(false);

                const response = await fetch("/api/uploadWorkVideo", {
                    method: "POST",
                    body: formData,
                    headers: {
                        Accept: "application/json",
                        "X-CSRF-TOKEN": document
                            .querySelector('meta[name="csrf-token"]')
                            .getAttribute("content"),
                    },
                });

                if (!response.ok) {
                    try {
                        const responseData = await response.json();
                        throw new Error(responseData.message);
                    } catch (parseError) {
                        throw new Error(
                            "Ошибка при загрузке файла. Попробуйте снова."
                        );
                    }
                }

                const responseData = await response.json();
                setIsProcessingFinished(true);
                setDownloadUrl(responseData.url);
                setIsLoading(false);
                setIsDownloading(false);
                props.setShowUploader(false);
                document.body.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
                console.log("File uploaded successfully:", responseData.url);
            } catch (error) {
                setIsLoading(false); // Обязательно сброс состояния
                setIsDownloading(false);
                setIsProcessingFinished(false);
                console.error("Error uploading file:", error.message);
            }
        }
    };

    return (
        <Container>
            {showVariants && (
                <div className="px-4 py-2">
                    <div>
                        {titleCurrentFile}: {props.fileName}
                    </div>
                    <div
                        style={{
                            borderRadius: "4px",
                            backgroundColor: "lightblue",
                            color: "darkblue",
                        }}
                        className="w-full flex items-center text-white text-sm font-bold px-4 py-3"
                        role="alert"
                    >
                        {tip1}
                    </div>

                    <div className="flex justify-center px-4 py-3">
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg mx-2 text-lg"
                            onClick={() => handleRepair(1)}
                        >
                            {titleVariant1}
                        </button>
                        <button
                            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-lg mx-2 text-lg"
                            onClick={() => handleRepair(2)}
                        >
                            {titleVariant2}
                        </button>
                        <button
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg mx-2 text-lg"
                            onClick={() => handleRepair(3)}
                        >
                            {titleVariant3}
                        </button>
                        <button
                            className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded-lg mx-2 text-lg"
                            onClick={() => handleRepair(4)}
                        >
                            {titleVariant4}
                        </button>
                        <button
                            className="bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg mx-2 text-lg"
                            onClick={() => handleRepair(5)}
                        >
                            {titleVariant5}
                        </button>
                    </div>
                </div>
            )}
            {showUploadMessage && (
                <div>
                    <UploadMessage>{tip2}</UploadMessage>
                    <ButtonContainer>
                        <input type="file" onChange={handleFileUpload} />
                    </ButtonContainer>
                </div>
            )}
            {showVariant5Message && (
                <div>
                    <UploadMessage>{tip4}</UploadMessage>
                    <div>
                        <label>
                            <input
                                type="radio"
                                name="videoOrientation"
                                value="horizontal"
                                checked={selectedOrientation === "horizontal"}
                                onChange={(e) =>
                                    setSelectedOrientation(e.target.value)
                                }
                            />
                            {titleHorizontal}
                        </label>
                        <br />
                        <label>
                            <input
                                type="radio"
                                name="videoOrientation"
                                value="vertical"
                                checked={selectedOrientation === "vertical"}
                                onChange={(e) =>
                                    setSelectedOrientation(e.target.value)
                                }
                            />
                            {titleVertical}
                        </label>
                    </div>
                    <ButtonContainer>
                        <StyledButton onClick={() => handleRepair5()}>
                            {titleRepair}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div
                            className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                            role="alert"
                        >
                            {errorMessage}
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleRepairAnotherVideo}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader
                        color={"#123abc"}
                        loading={isLoading}
                        size={150}
                    />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <div>
                    <StyledMessage>{titleReady}</StyledMessage>
                    <div className="px-4 py-2">
                        <AVReactPlayer videoUrl={downloadUrl} />
                    </div>
                    <ButtonContainer>
                        <a
                            href={downloadUrl}
                            download={getFileName(downloadUrl)}
                            onClick={handleDownload}
                        >
                            <StyledButton>{titleDownload}</StyledButton>
                        </a>
                        <a className="pl-2" onClick={handleDownload}>
                            <StyledButtonDelete>
                                {titleDelete}
                            </StyledButtonDelete>
                        </a>
                    </ButtonContainer>
                </div>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>
                            {titleRepairAnotherVideo}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default AVRepair;
